import React, { CSSProperties, FunctionComponent } from 'react'
import styles from './style.module.scss'
import clsx from 'clsx'

interface FlexProps {
  direction?: CSSProperties['flexDirection']
  className?: string
  alignItems?: CSSProperties['alignItems']
  wrap?: CSSProperties['flexWrap']
  justifyContent?: CSSProperties['justifyContent']
  fullWidth?: boolean
  testNameSpace?: string
  children: React.ReactNode
}

export const Flex: FunctionComponent<FlexProps> = ({
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'flex-start',
  wrap = 'nowrap',
  fullWidth = false,
  testNameSpace = '',
  className,
  children,
}) => {
  const cls = clsx(
    styles.flex,
    styles[`direction-${direction}`],
    styles[`justify-${justifyContent}`],
    styles[`align-${alignItems}`],
    styles[`wrap-${wrap}`],
    fullWidth && styles['full-width'],
    testNameSpace,
    className
  )

  return (
    <div className={cls} {...(testNameSpace && { 'data-testid': `${testNameSpace}-flex` })}>
      {children}
    </div>
  )
}
